<template>
<div class="product-add">
  <el-form size="small" ref="form" :model="formData" :rules="rules" label-width="150px">
    <div class="common-form">电话设置</div>
    <el-form-item label="客服电话" prop="service_tel">
      <el-input v-model="formData.service_tel" style="width: 300px;"></el-input>
    </el-form-item>
    <el-form-item label="联盟商电话" prop="store_tel">
      <el-input v-model="formData.store_tel" style="width: 300px;"></el-input>
    </el-form-item>
    <el-form-item label="微信号" prop="wechat_id">
      <el-input v-model="formData.wechat_id" style="width: 300px;"></el-input>
    </el-form-item>

    <el-form-item label="客服二维码" prop="service_qrcode.file_id" :rules="[{ required: true, message: '请上传客服二维码', trigger: 'change' }]">
    <el-button type="primary" @click="isupload=true">选择图片</el-button>
    <div v-if="formData.service_qrcode.file_id" class="img">
      <img :src="formData.service_qrcode.file_path" width="100" height="100" />
    </div>
  </el-form-item>

    <!--提交-->
    <div class="common-button-wrapper">
      <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
    </div>
  </el-form>


<Upload v-if="isupload" :isupload="isupload" @returnImgs="uploadChange">上传图片</Upload>


</div>

</template>

<script>
import Upload from '@/components/file/Upload';
import SettingApi from '@/api/setting.js';
export default {
  components:{Upload},
  data() {
    return {
      isupload:false,
      formData:{
        service_tel:'',
        store_tel:'',
        wechat_id:'',
        service_qrcode:'',
      },
      rules:{
        service_tel: [{ required: true, message: '请输入客服电话', trigger: 'blur' }],
        store_tel: [{ required: true, message: '请输入联盟商电话', trigger: 'blur' }],
      },
      loading:false,
    };
  },
  created() {
    this.getParams()
  },

  methods: {

    getParams() {
      let self = this;
      SettingApi.getTelIndex({}, true).then(data => {
        if (data.code == 1) {
          let vars = data.data.vars.values;
          this.formData=vars
        }
      })
    },
    onSubmit() {
      let self = this;
      self.loading = true;
      let form = self.formData;
      SettingApi.setTelIndex(form, true).then(data => {
        self.loading = false;
        self.$message({
          message: '恭喜你，交易设置成功',
          type: 'success'
        });
      }).catch(error => {
        self.loading = false;
      });
    },

      // 图片上传
      uploadChange(e){
      if(e&&e!=''){
        this.formData.service_qrcode=e[0]
      }
      this.isupload=false
    },


  }

};
</script>

<style>
.tips {
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/tel/index.vue